import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import CustomButton from "components/Atoms/CustomButton"
import CustomButtonGroup from "components/Atoms/CustomButtonGroup"
import { useSearchFilter } from "hooks/searchFilterHooks"

const HistorySwitch = ({ className, active, onClick }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [{ date, type, view }] = useSearchFilter()
  return (
    <CustomButtonGroup joint className={className}>
      <CustomButton
        intent={view === "history" ? "none" : "primary"}
        icon="tick-circle"
        text="Requests"
        onClick={() =>
          navigate(
            `/d/ecom/approval-stock-take/${id}?type=${
              type || "sellable-item"
            }&date=${date}`
          )
        }
      />
      <CustomButton
        intent={view === "history" ? "primary" : "none"}
        icon="refresh"
        text="History"
        onClick={() =>
          navigate(
            `/d/ecom/approval-stock-take/${id}?type=${
              type || "sellable-item"
            }&date=${date}&view=history`
          )
        }
      />
    </CustomButtonGroup>
  )
}

export default HistorySwitch
